const MODAL_ABOUT_CONFIG = {
  backdrop: true,
  ignoreBackdropClick: false,
  class: 'gray modal-about',
  id: 1
};
export default MODAL_ABOUT_CONFIG;
